import $ from 'jquery';
import JqueryCookie from 'jquery-cookie';
import _ from 'underscore';
import Backbone from 'backbone';
import Handlebars from 'handlebars';
import Ladda from 'ladda';
import Global from 'models/Global';
import Poll from 'models/Poll';
import Event from 'models/Event';
import MainBaseView from 'views/MainBaseView';
import QuestionView from 'views/QuestionView';
import thankYouForVotingTemplate from 'hbars!templates/thankYouForVoting';
import FeatureToggleUtils from 'FeatureToggleUtils';
import BootstrapData from 'models/BootstrapData';
import { instanaTrackPage } from '@bizzabo/instana-api';
import { sendAnalytics } from 'utils/analyticsUtils';
import { renderVirtualVenueBanner } from '../views/reactViews/VirtualVenueBanner';
import { renderAttendeeLogin } from '../views/reactViews/AttendeeLogin';
import { renderSsoEmailErrorModal } from '../views/reactViews/SsoEmailErrorModal';

var MainPollView = MainBaseView.extend({
    events: {
        'click .poll-submit-button': 'submitClicked'
    },

    initialize: function(options) {
        options = options || {};
        FeatureToggleUtils.mergeFeatureToggleWithConfig();
        MainBaseView.prototype.initialize.apply(this, arguments);

        instanaTrackPage('Polls');

        Global.set('page', 'poll');
        this.model = new Poll(options.bootstrapData.poll);
        this.event = new Event(options.bootstrapData.event);
        this.partner = !_.isEmpty(options.bootstrapData.partner) && new Backbone.Model(options.bootstrapData.partner);
        this.sessions = !_.isEmpty(options.bootstrapData.sessions) && new Backbone.Collection(options.bootstrapData.sessions);
        this.isJoined = options.bootstrapData.isJoined;

        this.model.get('questions').each(function(question) {
            new QuestionView({
                el: this.$('.poll-question-box[data-question-id="' + question.get('id') + '"]'),
                model: question
            });
        }, this);

        this.listenTo(this.model, 'change:pollCompleted', this.renderSubmit);
        renderVirtualVenueBanner();
        renderAttendeeLogin();
        renderSsoEmailErrorModal();
    },

    submitClicked: function(e) {
        if ($(e.currentTarget).hasClass('disabled')) {
            return;
        }

        if (!this.submitButton) {
            this.submitButton = Ladda.create(this.$('.poll-submit-button').get(0));
        }

        this.submitButton.start();

        var thisView = this;
        this.model.vote({
            success: function() {
                thisView.sendAnalytics('submitPoll');

                thisView.submitButton.stop();
                thisView.renderThankYouPage();
            },
            error: function(errCode) {
                thisView.submitButton.stop();
                var errMessage = 'Something went Wrong.';
                switch (errCode) {
                case 4003:
                    errMessage = 'Multiple Votes are Forbidden.';
                    break;
                case 4008:
                    errMessage = 'Poll is not Active.';
                    break;
                case 4000:
                    errMessage = 'Mandatory answer is missing.';
                    break;
                case 4030:
                    errMessage = 'Only Attendees can vote. Join the event!';
                    break;
                }
                this.$('.poll-submit-error-wrapper').text(errMessage);
                this.$('.poll-submit-error-wrapper').addClass('appear');
                setTimeout(function() {
                    thisView.$('.poll-submit-error-wrapper').removeClass('appear');
                }, 4000);
            },
            cookie: $.cookie
        });
    },

    renderSubmit: function() {
        this.$('.poll-submit-button').toggleClass('disabled', !this.model.get('pollCompleted'));
    },

    renderThankYouPage: function() {
        var thisView = this;
        var pollWrapperElement = this.$('.poll-wrapper');
        pollWrapperElement.fadeOut(500, function() {
            thisView.scrollToElement(undefined, 0, true);

            pollWrapperElement.html(thankYouForVotingTemplate({
                poll: thisView.model.toJSON(),
                partner: thisView.partner && thisView.partner.toJSON(),
                event: thisView.event.toJSON(),
                sessions: thisView.sessions && thisView.sessions.toJSON(),
                isJoined: thisView.me && thisView.me.get('isJoined')
            }));

            const viewResultsElem = $(pollWrapperElement).find('[data-id="view-results-button"]');
            viewResultsElem.on('click', function() {
                thisView.sendAnalytics('viewPollResults');
            });
        });
        pollWrapperElement.fadeIn(500);
    },

    sendAnalytics: function(eventName) {
        const pollName = this.model.get('name');
        sendAnalytics(eventName, {
            pollName,
        });
    }
});

const event = BootstrapData('bootstrap-data-event');
const me = BootstrapData('bootstrap-data-me');
const config = BootstrapData('bootstrap-data-config');
const isJoinedObject = BootstrapData('bootstrap-data-isJoinedObject');
const siteConf = BootstrapData('bootstrap-data-siteConf');
const poll = BootstrapData('bootstrap-data-poll');
const partner = BootstrapData('bootstrap-data-partner');
const sessions = BootstrapData('bootstrap-data-sessions');
const isCookieConsentEnabled = BootstrapData('bootstrap-data-isCookieConsentEnabled');

export default new MainPollView({
    el: $(document.body),
    bootstrapData: {
        event: event,
        eventID: event.id,
        me: me,
        config: config,
        siteConf: siteConf,
        poll: poll,
        partner: partner,
        isJoined: isJoinedObject.isJoined,
        sessions: sessions,
        isCookieConsentEnabled
    }
});


